import React from 'react';
import axios from 'axios';
import { Form, Input, Select, Card, Popconfirm, Button } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import stickyError from 'components/stickyError';
import SaveButton from 'components/SaveButton';
import AddressInput from 'components/AddressInput';
import CardListForm from 'components/CardListForm';
import globalFormItemLayout from 'components/Portal/formItemLayout';

const relationshipTypes = [
	{value: 'NEP', label: 'Aunt/Uncle'},
	{value: 'P', label: 'Child'},
	{value: 'CO', label: 'Companion'},
	{value: 'CT', label: 'Cousin'},
	{value: 'F', label: 'Friend'},
	{value: 'GP', label: 'Grandchild'},
	{value: 'GC', label: 'Grandparent'},
	{value: 'AUN', label: 'Nephew/Neice'},
	{value: 'C', label: 'Parent'},
	{value: 'SPO', label: 'Spouse'},
	{value: 'SB', label: 'Sibling'},
	{value: 'SP', label: 'Stepchild'},
	{value: 'SC', label: 'Step-Parent'},
	{value: 'STS', label: 'Step-Sibling'},
	{value: 'XS', label: 'Ex Spouse'},
	{value: 'DP', label: 'Domestic Partner'}
];

class AdditionalContactForm extends React.Component {
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (err) return console.error(err);
			this.props.onSave(this.props.contact.index, values);
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		const {
			Forename, Surname, Relation,
			Phone1, Phone2, Email, Street,
			City, Province, PostalCode, Country
		} = this.props.contact;
		const disabled = this.props.contact.saved || this.props.sectionDisabled;
		return (
			<Card>
				<Form onSubmit={this.handleSubmit}>
					{disabled && !this.props.sectionDisabled &&
						<Form.Item style={{textAlign:'right'}}>
							<Button icon="edit" onClick={this.props.onEdit.bind(this, this.props.contact.index)}>Edit</Button>
						</Form.Item>
					}
					{!disabled &&
						<Form.Item style={{textAlign:'right'}}>
							<Popconfirm title="Are you sure?" okText="Remove" cancelText="Cancel"
								onConfirm={this.props.onRemove.bind(this, this.props.contact.index)}>
								<Button type="danger" size="large" icon="delete">Remove</Button>
							</Popconfirm>
							<Button type="primary" htmlType="submit" icon="save">Save</Button>
						</Form.Item>
					}
					<Form.Item label="First Name" {...globalFormItemLayout}>
						{getFieldDecorator('Forename', {
							initialValue: Forename,
							rules: [{required: true, message: 'First name is required'}]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Last Name" {...globalFormItemLayout}>
						{getFieldDecorator('Surname', {
							initialValue: Surname,
							rules: [{required: true, message: 'Last name is required'}]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Relationship" {...globalFormItemLayout}>
						{getFieldDecorator('Relation', {
							initialValue: Relation,
							rules: [{required: true, message: 'Relationship is required'}]
						})(
							<Select showSearch disabled={disabled}
								filterOption={(inputValue, option) =>
									option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
								}>
								{relationshipTypes.map(option => {
									return <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
								})}
							</Select>
						)}
					</Form.Item>
					<Form.Item label="Cell Phone" {...globalFormItemLayout}>
						{getFieldDecorator('Phone1', {
							initialValue: Phone1,
							rules: [
								{pattern:/^[\+(0-9)-\s\.]{6,20}$/im, message: 'Invalid phone number'},
								{required: true, message: 'Cell Phone is required'}
						]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Secondary Phone" {...globalFormItemLayout}>
						{getFieldDecorator('Phone2', {
							initialValue: Phone2,
							rules: [
								{pattern:/^[\+(0-9)-\s\.]{6,20}$/im, message: 'Invalid phone number'},
							]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Email" {...globalFormItemLayout}>
						{getFieldDecorator('Email1', {
							initialValue: Email,
							rules: [
								{required: true, message: 'Email is required'},
								{type: 'email', message: 'Not a valid email address'}
							]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<div>
						<legend>Street Address</legend>
						<AddressInput
							form={this.props.form}
							disabled={disabled}
							address={{
								Street: Street,
								City: City,
								Province: Province,
								PostalCode: PostalCode,
								Country: Country
							}}
							getFieldDecorator={getFieldDecorator} />
					</div>
					<Form.Item>
						{getFieldDecorator('id', {
							initialValue: this.props.contact.id
						})(
							<Input type="hidden" />
						)}
					</Form.Item>
				</Form>
			</Card>
		);
	}
}
const WrappedAdditionalContactForm = Form.create()(AdditionalContactForm);

class EmergencyContacts extends React.Component {
	state = {
		primaryContact: {},
		contacts: []
	}
	handlePrimarySubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.updateFolio(this.props.form, 'Emergency')
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	loadAdditionalContacts = () => {
		axios.get(apiPath+'/contacts', {withCredentials: true}).then(result => {
			this.setState({
				primaryContact: result.data.find(contact => contact.type === 'C'),
				contacts: result.data
					.filter(contact => contact.type === '3')
					.map(contact => { contact.saved = true; return contact; })
					.sort((a,b) => parseInt(b.id) - parseInt(a.id))
			});
		}).catch(this.props.handleAxiosLoadError);
	}
	handleContactChange = (s) => {
		this.setState(s);
	}
	handleContactSave = (contact, s, index) => {
		let submitContact = Object.assign({}, contact);
		this.props.isLoading();
		axios({
			method: (submitContact.id) ? 'put' : 'post',
			url: apiPath+'/contact',
			data: submitContact,
			withCredentials: true
		}).then(result => {
			if (!submitContact.id) s.contacts[index].id = result.data[0];
			this.props.isDoneLoading();
			this.setState(s);
		}).catch(error => {
			this.props.isDoneLoading();
			this.props.handleAxiosSaveError(error);
		});
	}
	handleContactRemove = (contact, s) => {
		if (!contact.id) return this.setState(s);
		this.props.isLoading();
		axios.delete(apiPath+'/contact/'+contact.id, {withCredentials: true})
			.then(result => {
				this.props.isDoneLoading();
				this.setState(s);
			}).catch(error => {
				this.props.isDoneLoading();
				this.props.handleAxiosSaveError(error);
			});
	}
	componentWillMount() {
		this.loadAdditionalContacts();
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'personal/emergency');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'personal/emergency');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		const formItemLayout = Object.assign({className: 'inResco'}, globalFormItemLayout);
		const {
			Forename, Surname, Relation, Email, Phone1, Phone2,
			Street, City, Province, PostalCode, Country
		} = this.state.primaryContact;
		let i = -1;
		return (
			<div>
				<h2>Primary Emergency Contact</h2>
				<br />
				<Form onSubmit={this.handlePrimarySubmit}>
					<Form.Item label="First Name" {...formItemLayout}>
						{getFieldDecorator('Forename', {
							initialValue: Forename,
							rules: [{required: true, message: 'First name is required'}]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Last Name" {...formItemLayout}>
						{getFieldDecorator('Surname', {
							initialValue: Surname,
							rules: [{required: true, message: 'Last name is required'}]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Relationship" {...formItemLayout}>
						{getFieldDecorator('Relation', {
							initialValue: Relation,
							rules: [{required: true, message: 'Relationship is required'}]
						})(
							<Select showSearch disabled={disabled}
								filterOption={(inputValue, option) =>
									option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
								}>
								{relationshipTypes.map(option => {
									return <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
								})}
							</Select>
						)}
					</Form.Item>
					<Form.Item label="Email" {...formItemLayout}>
						{getFieldDecorator('Email1', {
							initialValue: Email,
							rules: [
								{required: true, message: 'Email is required'},
								{type: 'email', message: 'Not a valid email address'}
							]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Cell Phone" {...formItemLayout}>
						{getFieldDecorator('Phone1', {
							initialValue: Phone1,
							rules: [
								{pattern:/^[\+(0-9)-\s\.]{6,20}$/im, message: 'Invalid phone number'},
								{required: true, message: 'Phone number is required'}
							]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<Form.Item label="Other Phone #1" {...formItemLayout}>
						{getFieldDecorator('Phone2', {
							initialValue: Phone2,
							rules: [
								{pattern:/^[\+(0-9)-\s\.]{6,20}$/im, message: 'Invalid phone number'}
							]
						})(<Input disabled={disabled} />)}
					</Form.Item>
					<div>
						<legend>Street Address</legend>
						<AddressInput
							form={this.props.form}
							address={{
								Street: Street,
								City: City,
								Province: Province,
								PostalCode: PostalCode,
								Country: Country
							}}
							getFieldDecorator={getFieldDecorator} />
					</div>
					{<SaveButton
						disabled={!this.props.form.isFieldsTouched()}
						loading={this.props.getStatus().submitting} />}
				</Form>
				<h2>Additional Emergency Contacts</h2>
				<br />
				<CardListForm title="Additional Contact" thing="contacts" contacts={this.state.contacts} disabled={disabled}
					onChange={this.handleContactChange} onSave={this.handleContactSave} onRemove={this.handleContactRemove}>
					{this.state.contacts.map(contact => {
						i++;
						contact.index = i;
						let key = i;
						if (contact.id) key += ''+contact.id;
						return (
							<WrappedAdditionalContactForm key={key} contact={contact} sectionDisabled={disabled} />
						);
					})}
				</CardListForm>
			</div>
		);
	}
}

export default withSpin(Form.create()(EmergencyContacts));



// WEBPACK FOOTER //
// ./portal-components/Portal/Personal/EmergencyContacts.jsx